import request from '@/utils/request'

export interface Entitlement {
  id?: number
  userId: string
  featureId?: number
  featureKey?: string
  sourceType: string
  sourceReference?: string
  startDate?: Date | string | null
  endDate?: Date | string | null
  isActive: boolean
  revocationReason?: string
  metadataJson?: any
  createdAt?: Date
  updatedAt?: Date
  feature?: {
    id: number
    featureKey: string
    name: string
    description?: string
  }
}

export interface Feature {
  id: number
  featureKey: string
  name: string
  description?: string
  isActive: boolean
  configJson?: any
  createdAt?: Date
  updatedAt?: Date
}

export interface GrantEntitlementRequest {
  userId: string
  featureKey: string
  sourceType: string
  sourceReference?: string
  startDate?: Date | string | null
  endDate?: Date | string | null
  metadata?: Record<string, any>
}

export const getUserEntitlements = (userId: string, includeInactive?: boolean) =>
  request({
    url: `/users/${userId}/entitlements`,
    method: 'get',
    params: { includeInactive }
  })

export const checkFeatureAccess = (userId: string, featureKey: string) =>
  request({
    url: `/users/${userId}/features/${featureKey}/check`,
    method: 'get'
  })

export const getFeatureExpiry = (userId: string, featureKey: string) =>
  request({
    url: `/users/${userId}/features/${featureKey}/expiry`,
    method: 'get'
  })

export const grantEntitlement = (data: GrantEntitlementRequest) =>
  request({
    url: `/users/${data.userId}/entitlements`,
    method: 'post',
    data
  })

export const revokeEntitlement = (userId: string, featureKey: string, reason?: string) =>
  request({
    url: `/users/${userId}/features/${featureKey}/entitlements`,
    method: 'delete',
    data: { reason }
  })

export const revokeEntitlementById = (userId: string, entitlementId: number, reason?: string) =>
  request({
    url: `/users/${userId}/entitlements/${entitlementId}`,
    method: 'delete',
    data: { reason }
  })

export const listFeatures = () =>
  request({
    url: '/features',
    method: 'get'
  })

export const bulkGrantEntitlements = (grants: GrantEntitlementRequest[]) =>
  request({
    url: '/entitlements/bulk-grant',
    method: 'post',
    data: { grants },
    timeout: 300000 // 5 minutes for bulk operations
  })
